<template>
    <div class="main-container">
        <h1 class="title">{{title}}</h1>
        <div v-for="restaurant in viewedData" :key="restaurant.id">
            <div
              class="location-container d-flex flex-row"
              :class="[restaurant.id === activeId ? 'active-click' : '']"
              :id="'id' + restaurant.id"
            >
              <div class="location-left d-flex flex-column" @click="zoomMarker(restaurant)">
                <h1>{{restaurant.name}}</h1>
                <div class="info-loc d-flex flex-row">
                  <div class="description d-flex flex-column justify-content-around">
                    <div class="d-flex flex-row">
                      <div class="first-col d-flex flex-column">
                        <i class="far fa-map-marker-alt"></i>
                      </div>
                      <div class="first-col d-flex flex-column">
                        <p>{{restaurant.streetaddress}}</p>
                        <p>{{restaurant.city}}, {{restaurant.state}} {{restaurant.zip}}</p>
                      </div>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="first-col d-flex flex-column">
                        <i class="far fa-shopping-bag"></i>
                      </div>
                      <div class="first-col d-flex flex-column">
                        <p v-if="restaurant.candeliver && restaurant.canpickup">Delivery and Pickup</p>
                        <p v-if="restaurant.candeliver && !restaurant.canpickup">Delivery</p>
                        <p v-if="!restaurant.candeliver && restaurant.canpickup">Pickup</p>
                        
                      </div>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="first-col d-flex flex-column">
                        <i class="fal fa-clock"></i>
                      </div>
                      <div class="first-col d-flex flex-column">
                        <p>Open Now</p>
                      
                      </div>
                    </div>
                    <div v-if="!checkDeliveryType(restaurant)" class="error-message">
                      <p>Chosen delivery type is not supported</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="location-right d-flex align-items-center justify-content-end">
                <button
                  class="right-btn d-flex flex-row align-items-center justify-content-center"
                  @click="makeOrder(restaurant)"
                >
                  <i class="far fa-shopping-bag"></i>
                  <span>Order Now</span>
                </button>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: 'restaurantView',
    props: ['title', 'viewedData'],
    data(){
        return{
          activeId: null
        }
    },
    computed: {
      ...mapState(["info"]),
    },
    watch:{
      viewedData: function(newData, oldData){
        this.activeId = this.viewedData[0].id;
        this.$emit('zoom', this.viewedData[0]);
      }
    },
    methods: {
      makeOrder(restaurant){
        if(this.checkDeliveryType(restaurant)){
          this.$emit('makeOrder', restaurant);
        }
      },
      zoomMarker(restaurant){
        this.activeId = restaurant.id;
        this.$emit('zoom', restaurant);
      },
      checkDeliveryType(restaurant){
        switch(this.info.method){
          case 'pickup':{
            return restaurant.canpickup;
            break;
          }
          case 'curbside':{
            return restaurant.supportscurbside;
            break;
          }
          case 'delivery':{
            return restaurant.candeliver || restaurant.supportsdispatch;
            break;
          }
          case 'drivethru':{
            return restaurant.supportsdrivethru;
            break;
          }
        }
      }
    },
    created(){
      if(this.viewedData.length > 0){
        this.activeId = this.viewedData[0].id;
        this.$emit('zoom', this.viewedData[0]);
      }
    }
}
</script>
<style scoped>
input, button
{
  border: none;
  padding: 0;
  background: none;
  outline: none;
}
.main-container{
  margin-top: 1.5em;
  width: 100%;
}
.title{
  font-family: "Poppins", sans-serif;
  height: 23px;	
  width: 254px;	
  opacity: 0.4;	
  color: #000000;	
  font-size: 16px;	
  font-weight: bold;	
  line-height: 25px;
  margin-bottom: 1em;
}
.location-left {
  width: 60%;
  padding: 24px 30px;
  transition: 1s;
}
.location-right {
  width: 50%;
  transition: 1s;
  padding-right:36px;
}
.right-btn {
  height: 48px;
  width: 134px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: var(--main-color);
  font-size: 11px;
  font-weight: bold;
  transition: 1s;
}
.right-btn i {
  height: 16px;
  width: 14px;
  color: var(--main-color);
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  margin-right: 10px;
  transition: 1s;
}
.right-btn span {
  height: 19px;
  width: 71px;
  color: var(--main-color);
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  transition: 1s;
}
.location-left h1 {
  font-family: "Poppins", sans-serif;
  opacity: 0.8;
  font-weight: bold;
  font-size: 14px;
}
.location-left p {
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 500;
  opacity: 0.6;
  margin: 0;
  line-height: 17px;
  text-align: left;
}
.location-left .error-message p{
  color: var(--main-color);
}
.location-left p > img {
  width: 18px;
  height: 14px;
}
.location-container {
  width: 100%;
}
.line-between {
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  border: 1px solid #000000;
  opacity: 0.05;
}
.logo-title {
  padding: 25px;
}
.logo-title img {
  /* width: 96px; */
  height: 96px;
  border-radius: 25px;
}
.description {
  display: table-cell;
  vertical-align: middle;
  /* padding: 5px 10px; */
  margin-top: 5px;
}
.description p {
  /* height: 38px;
    width: 121px; */
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  display: inline-block;
  vertical-align: middle;
}
.description p i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-left: 5px;
}
.first-col i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  /* color: #000000; */
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-top: 2px;
  margin-right: 8px;
}
.first-col p {
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
}
.icon i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  text-align: center;
}
/* .location-container:hover .location-left {
  background-color: rgba(255, 251, 0, 0.1);
  transition: 1s;
}
.location-container:hover .location-right .right-btn {
  background-color: var(--main-color);
  transition: 1s;
}
.location-container:hover .location-right {
  background-color: rgba(255, 251, 0, 0.1);
  transition: 1s;
}
.location-container:hover .location-right .right-btn i {
  color: white;
  transition: 1s;
}
.location-container:hover .location-right .right-btn span {
  color: white;
  transition: 1s;
} */
.active-click{
  border: 1px solid rgba(0,0,0,0.1);	
  border-radius: 8px;
}
.active-click .location-left {
  background-color: #ffffff;
  border-radius: 8px;
  transition: 1s;
}
.active-click .location-right .right-btn {
  background-color: var(--main-color);
  transition: 1s;
}
.active-click .location-right {
  background-color: #ffffff;
  border-radius: 8px;
  transition: 1s;
}
.active-click .location-right .right-btn i {
  color: white;
  transition: 1s;
}
.active-click .location-right .right-btn span {
  color: white;
  transition: 1s;
}
.current-button {
  color: var(--main-color);
}
</style>
<style>
.location-left {
  padding: 24px 30px;

}
.location-left h1 {
  font-family: "Poppins", sans-serif;
  opacity: 0.8;
  font-weight: bold;
  font-size: 14px;
}
.location-left p {
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 500;
  opacity: 0.6;
  margin: 0;
  line-height: 17px;
  text-align: left;
}
.description {
  display: table-cell;
  vertical-align: middle;
  /* padding: 5px 10px; */
  margin-top: 5px;
}
.description p {
  /* height: 38px;
    width: 121px; */
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  display: inline-block;
  vertical-align: middle;
}
.description p i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-left: 5px;
}
.first-col i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  /* color: #000000; */
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-top: 2px;
  margin-right: 8px;
}
.first-col p {
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
}
.popup-btn {
  height: 48px;
  width: 134px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: var(--main-color);
  font-size: 11px;
  font-weight: bold;
  transition: 1s;
}
.popup-btn i {
  height: 16px;
  width: 14px;
  color: var(--main-color);
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  margin-right: 10px;
  transition: 1s;
}
.popup-btn span {
  height: 19px;
  width: 71px;
  color: var(--main-color);
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  transition: 1s;
}
.location-right {
  width: 50%;
  transition: 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/custom/restaurantView.vue